import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import {
  BOG_LINE_GAME_TYPES,
  DefaultQueryParams,
  freeBetStore,
  isMobile,
  parseQuery,
} from '@pascal/pascal-core';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';

import { gameLiveConnection, gameService, registerApis } from '../../services';
import { gameName } from '../../enums/gameConfigsAndUrls';
import { soundService } from '../../services/soundService';
import { resizeGameHandler } from '../../helpers/resizeGame';
import { liveConnection } from '../liveConnection';
import { reBetStore } from '../../store/reBetStore';
import { doBetStore } from '../../store/doBetStore';
import { gameNameDependGameIds } from '../../enums/gameConstant';

export const init = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);

  if (gameNameDependGameIds[gameId]) {
    document.documentElement.classList.add(`${gameNameDependGameIds[gameId]}`);
  }

  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    gameService,
    soundService,
    liveConnection,
    gameLiveConnection,
  });
  registerApis();
  gameConfigStore.initGameConfigs(
    {
      sectionCount: 3,
      bogLineGameTypeData: {
        gameType: BOG_LINE_GAME_TYPES.ONLY_CRASH,
        isUsedStakeUpdateLogic: true,
        isUsedPlatformIntegrationLogic: true,
        gameName,
      },
      isUsedBogLineComponents: false,
      initPlatformMessageConfigs: true,
      isAllSectionWithCashOutButton: true,
      isUsedInputValidationFunctionality: false,
      isUsedRoundStartAndFinishedLogicAfterCashOut: false,
    },
    {
      isGameHasPixi: true,
      onGameTypeChangeCallback: () => {
        reBetStore.setReBetInfo([]);
        freeBetStore.resetActiveFreeBet();
        freeBetStore.resetExtraFreeBetData();
        doBetStore.resetPigsData();
      },
      onFreeBetDeactivateCallback: () => {
        reBetStore.setReBetInfo([]);
        doBetStore.resetPigsDataOnFreeBetToggle();
      },
      onFreeBetActivateCallback: () => {
        reBetStore.setReBetInfo([]);
        doBetStore.resetPigsDataOnFreeBetToggle();
      },
      onFreeBetEndedCallback: () => {
        reBetStore.setReBetInfo([]);
      },
    }
  );
};
